import { DeleteButton, EditButton, List, Table, useTable } from "@pankod/refine-antd";
import { useCompany } from "context/CompanyContext";
import React from "react";

export const PostList: React.FC = () => {
  const { id } = useCompany();

  const { tableProps } = useTable({
    resource: "post",
    initialSorter: [
      {
        field: "order",
        order: "asc",
      },
    ],
    permanentFilter: [
      {
        field: "topic.category.company_id",
        operator: "eq",
        value: id,
      },
    ],
    metaData: {
      join: [
        {
          field: "topic",
        },
        {
          field: "topic.category",
        },
        {
          field: "user",
        },
      ],
    },
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "content",
      dataIndex: "content_raw",
      key: "content",
      render: (value: any) => {
        return <span>{(value || "").substring(0, 30)}</span>;
      },
    },
    {
      title: "Topic",
      dataIndex: ["topic", "name"],
      key: "topic",
      sorter: true,
    },
    {
      title: "Created by",
      dataIndex: ["user", "email"],
      key: "user",
      sorter: true,
    },
    {
      title: "Actions",
      render: (_: any, record: any) => {
        return (
          <div className="flex space-x-2">
            <EditButton shape="circle" hideText recordItemId={record.id} resourceNameOrRouteName="admin/chat/post" />
            <DeleteButton shape="circle" hideText recordItemId={record.id} resourceNameOrRouteName="post" />
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <h1 style={{fontSize: 35, marginTop:20, color:"rgb(4, 6, 10, 0.8)"}}>Chat</h1>
    <List title="Posts" canCreate>
      <Table {...tableProps} rowKey="id" columns={columns} />
    </List>
    </div>
  );
};
